export const mobileFooterHeight = 130
export const a4width = '297'
export const a4height = '210'
export const fadeAnimation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
}
